import React from 'react';

import ModalBoxes from '../../../../../../common/feedback/ModalBoxes/ModalBoxes';
import Button from '../../../../../../common/general/Button';

import LogRowSignaturesHistory from './LogRowSignaturesHistory';

export default function LogRowSignaturesHistoryModal({ modalBox, history, adverseEventHistory }) {
  return (
    <>
      <ModalBoxes.Body>
        <LogRowSignaturesHistory history={history} adverseEventHistory={adverseEventHistory} />
      </ModalBoxes.Body>
      <ModalBoxes.Footer>
        <Button priority="medium" onClick={modalBox.close}>
          Close
        </Button>
      </ModalBoxes.Footer>
    </>
  );
}

LogRowSignaturesHistoryModal.className = 'ae-log-row-signatures-history-modal';
LogRowSignaturesHistoryModal.size = 'w1250';
